import { useCallback, useMemo, useState } from "react";

import { ExerciseTag } from "~/components/ExerciseTag";
import { SelectInput } from "~/components/SelectInput";
import type { Option } from "~/types/types";

import { defaultExerciseData as personalTrainerExercises } from "../data";
import { CreateExerciseForm } from "./CreateExerciseForm";

type Props = {
	group: string | undefined;
};

export const EditGroupForm: React.FC<Props> = ({ group }) => {
	const [baseGroup, setBaseGroup] = useState<string>("");

	const strengthExercisesOptions = useMemo<Option<string>[]>(
		() =>
			personalTrainerExercises?.strengthExercises.map<Option<string>>((e) => ({
				label: e.groupName,
				value: e.groupName,
			})) ?? [],
		[],
	);

	const strengthExercises = useMemo(
		() =>
			personalTrainerExercises?.strengthExercises.find(
				(se) => se.groupName === baseGroup,
			)?.exercises ?? [],
		[baseGroup],
	);

	const standardizedSeriesExercises = useMemo(
		() =>
			personalTrainerExercises?.standardizedSeries.find(
				(se) => se.groupName === group,
			)?.exercises ?? [],
		[group],
	);

	const handleAddExerciseToGroup = useCallback(async () => {
		//
	}, []);

	const handleRemoveExerciseToGroup = useCallback(async () => {
		if (!group) return;
	}, [group]);

	return (
		<div className="flex flex-col">
			<p>Selecione um grupo para adicionar atividades</p>
			<div className="flex flex-col gap-3">
				<SelectInput
					options={strengthExercisesOptions}
					value={baseGroup}
					onChange={setBaseGroup}
				/>
				<div className="flex flex-wrap p-2 bg-slate-100 rounded-lg max-h-[200px] overflow-y-auto gap-2">
					{strengthExercises.map((e) => (
						<ExerciseTag
							key={`exercise-${e.replace(" ", "_")}`}
							onAdd={() => handleAddExerciseToGroup()}
							exercise={e}
						/>
					))}
				</div>

				<div>
					<p>Adicione um novo exercício para a série (opcional)</p>
					<CreateExerciseForm group={group} />
				</div>

				<p>Exercícios da série</p>
				<div className="flex flex-wrap p-2 bg-slate-100 rounded-lg max-h-[200px] overflow-y-auto gap-2">
					{standardizedSeriesExercises.map((e) => (
						<ExerciseTag
							key={`exercise-${e.replace(" ", "_")}`}
							onDelete={() => handleRemoveExerciseToGroup()}
							exercise={e}
						/>
					))}
				</div>
			</div>
		</div>
	);
};
